<app-metadata-view
  [boldValue]="boldValue"
  [icon]="displayDate ? icon : null"
  [iconTooltip]="iconTooltip | translate"
  [darkText]="true"
  [metadataDescriptionTranslationKey]="descriptionTranslationKey"
  [metadataValue]="displayDate ? (displayDate | localDate: dateFormat) : '--'">
</app-metadata-view>
